import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";

import { getTopPublishers } from "../../../redux/slices/dashboardSlice";
const AllPublishers = () => {
  const dispatch = useDispatch();
  const { topPublishers } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(getTopPublishers());
  }, [dispatch]);

  return (
    <AdvertiserList>
      {topPublishers.length === 0 ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          No publisher available.
        </div>
      ) : (
        topPublishers.slice(0, 3).map((publisher) => (
          <AdvertiserCard>
            <AdvertiserHeader>
              {/* <img src={publisher?.imageUrl} alt={publisher?.name} /> */}
              <h4>{publisher?.publishername}</h4>
            </AdvertiserHeader>
            <Stats>
              <Stat>
                <Label>Campaigns</Label>
                <Value>{publisher?.totalcampaigns}</Value>
              </Stat>
              <Stat>
                <Label>Clicks</Label>
                <Value>{publisher?.totalreach}</Value>
              </Stat>
              <Stat>
                <Label>Conversions</Label>
                <Value>{publisher?.totalacquistion}</Value>
              </Stat>
            </Stats>
          </AdvertiserCard>
        ))
      )}
    </AdvertiserList>
  );
};

export default AllPublishers;

const AdvertiserList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const AdvertiserCard = styled.div`
  //display: flex;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;
const AdvertiserHeader = styled.div`
  display: flex;
  gap: 20px;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }
  h4 {
    margin-top: 15px;
    font-size: 16px;
    text-transform: capitalize;
  }
`;
const Stats = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 12px;
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  text-align: left;
`;

const Label = styled.span`
  font-size: 12px;
  color: #989fad;
`;

const Value = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #48505e;
`;
